// The therapist's own monthly report lives behind a signed token, and three places
// link to it: the salary row, the copy-link action, and the therapist card. One
// builder so a change to the route can never leave one of them pointing elsewhere.
export const monthlyReportLink = (token: string) =>
  `${window.location.origin}/salary/report?t=${encodeURIComponent(token)}`;
